import React from 'react'
// libs
import styled from 'styled-components'
import { useRouter } from 'hooks/useRouter'
// hooks
import { useCurrentUser } from 'hooks/useCurrentUser'
// components
import {
  TemplateSettingsButton,
  ChangeVisibilityButton,
  UnarchiveTemplateButton,
  DeleteRiskTemplateButton,
  ShowArchivedFieldsButton,
  AddSystemProcessesButton
} from 'components/CTAs'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'

const CTAWrapper = styled.div`
  display: flex;
  gap: 12px;
`

const RiskTemplateCTA: React.FC = () => {
  const router = useRouter()

  const { riskTemplate, hasInactiveFields, updateRiskTemplate } = React.useContext(RiskTemplateAPIContext)

  const {
    permissionsFromSecurityGroups: { manageRiskTemplates }
  } = useCurrentUser()

  if (!manageRiskTemplates) {
    return null
  }

  return (
    <CTAWrapper>
      <ChangeVisibilityButton
        entityType='form'
        entity={riskTemplate}
        onSetVisibility={updateRiskTemplate}
        disabled={!riskTemplate.permissions?.riskSetSecurity}
      />
      {!riskTemplate.archived && <AddSystemProcessesButton />}
      {(router.query.archived || hasInactiveFields) && <ShowArchivedFieldsButton />}
      <TemplateSettingsButton />
      {riskTemplate.archived ? <UnarchiveTemplateButton /> : <DeleteRiskTemplateButton templateId={riskTemplate?.id} />}
    </CTAWrapper>
  )
}

export default RiskTemplateCTA
